export const ASSET_PACK_VERSION = 'towerarena-assets-1';
